import React, { useState, useContext } from 'react';
import Parse from 'parse';
import swal from 'sweetalert';
import { Redirect } from 'react-router-dom';
import { AuthContext } from '../../auth';
import Navbar from '../layouts/navbar';
import { Link } from 'react-router-dom'
import { PeerjsContext } from '../../peerContext';
import Peer from 'peerjs';



const Login = () => {

    const [name, setName] = useState("");
    const [pass, setPass] = useState("");
    const [logedinuser, setLogedinuser] = useContext(AuthContext);
    const peerRef = useContext(PeerjsContext);

    const handleSubmit = (e) => {
        e.preventDefault();
        async function fn() {
            // TODO: Add try catch
            try {
                const user = await Parse.User.logIn(name, pass);
                console.log(user);
                console.log(user.get("counsellor"));
                const isCounsellor = user.get("isCounsellor");
                if (!user) {
                    swal("Oops!", "no user..wrong email or password", "error");
                } else {
                    if (isCounsellor) {
                        setLogedinuser(user.id);
                        setLogedinuser(user.id);
                        peerRef.current = new Peer();
                        console.log('Connecting peer');
                        peerRef.current.on('open', function (id) {
                            console.log(id);
                            user.set("peerId", id);
                            user.save().then((obj) => {
                                console.log("saved" + obj);
                            }).catch(err => {
                                console.log(err);
                            })

                            //send id to parse
                        });
                    } else {
                        swal("Oops!", "you are not a counsellor registered in app", "error");
                    }
                }
            }
            catch (e) {
                console.log(e)
                swal("Oops!", "no user..wrong email or password", "error");
            }
        }

        fn();
    }
    return (
        <div>
            <Navbar head="Counsellor Login" />
            {console.log(logedinuser)}
            {(logedinuser != null) && (
                <Redirect to="/counsellor/" />
            )}
            <div className="container" style={{marginTop:"50px"}}>
                {/* <Logincard /> */}
                <h1 className="head1">Login to your Account</h1>
                <form onSubmit={handleSubmit}>
                    <div className="row">
                        <div className="form-group col-lg-12  ">
                            <input type="text"
                                className="form-control"
                                id="exampleInputEmail1"
                                value={name}
                                onChange={e => setName(e.target.value)}
                                aria-describedby="emailHelp"
                                placeholder="user name" />
                        </div>
                        <div className="form-group col-lg-12 ">
                            <input type="password"
                                className="form-control"
                                id="pwd"
                                value={pass}
                                onChange={e => setPass(e.target.value)}
                                placeholder="password" />
                        </div>
                        {/* <div className="checkbox">
                            <label><input type="checkbox" value="" />Remember me</label>
                        </div> */}

                    </div>
                    <div className="btndiv">
                        <button type="submit" className="authbtn btn-primary center-block mt-4">Submit</button>
                    </div>
                </form>
                <div className="signupdiv">Dont have an account? <br /><Link to="/counsellor/register">Sign up</Link></div>
            </div>
        </div>
    );
};



export default Login;


